/**
 * Format a numeric amount as a localized currency string.
 *
 * @param {number|string} amount
 * @param {string} [currency] - defaults to 'USD'
 * @returns {string}
 */
export function formatMoney(amount, currency = 'USD') {
  if (amount === null || amount === undefined || amount === '') {
    return '—';
  }

  const numericValue = Number(amount);
  if (!Number.isFinite(numericValue)) {
    return amount || '—';
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
    }).format(numericValue);
  } catch {
    return `${amount} ${currency}`;
  }
}
